var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSecurityBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6H6V9H7.5V6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5H6V13.5H7.5V10.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H10.5V9H12V6Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5H10.5V13.5H12V10.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15H6V18H7.5V15Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15H10.5V18H12V15Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.91H15V3H3V21H12.93V22.5H1.5V3C1.5 2.6 1.66 2.22 1.94 1.94C2.22 1.66 2.6 1.5 3 1.5H15C15.4 1.5 15.78 1.66 16.06 1.94C16.34 2.22 16.5 2.6 16.5 3V10.91Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.36 12.36V18.7C14.36 20.51 15.48 22.25 17.16 23.04L19.18 24L21.2 23.04C22.9 22.29 24 20.58 24 18.7V12.36H14.36ZM22.47 18.7C22.47 19.9 21.71 21.12 20.61 21.67L19.18 22.33L17.76 21.67C16.6 21.09 15.89 19.96 15.89 18.7V13.89H22.47V18.7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSecurityBuilding);
export default __webpack_public_path__ + "static/media/ic-security-building.c55c82273130833ee2234764ca1a3e4d.svg";
export { ForwardRef as ReactComponent };